import axios from 'axios';

axios.defaults.baseURL = process.env.VUE_APP_API_URL;


const instance = axios.create({
    baseURL: process.env.VUE_APP_API_URL
})

export default instance;
// export default (app) => {
//     app.axios = axios;
//     app.$http = axios;

//     app.config.globalProperties.axios = axios;
//     app.config.globalProperties.$http = axios;
    
// }

// abstract class HttpClient {
//     protected readonly instance: AxiosInstance;

//     public constructor(baseURL: string) {
//     this.instance = axios.create({
//         baseURL,
//     });
//     }
// }